module.exports = __webpack_public_path__ + "img/9 filters B-07.7ba69050.png";